import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import breakpointsFunc from 'src/styles/breakpointsFunc';
const useStyles = makeStyles({
  batchBarWrapper: {
    position: 'sticky',
    bottom: '0',
    left: '0',
    right: '0',
    backgroundColor: palette.shades[100],
    padding: '24px 0',
    boxShadow: '0px -18px 32px 0px #00000026',
    zIndex: '10'
  },
  batchBarContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 15px',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      padding: '0 24px'
    }
  },
  selectInfo: {
    display: 'flex',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('lg')]: {
      marginBottom: '20px'
    }
  },
  selectCount: {
    marginLeft: '20px'
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    [breakpointsFunc.breakpoints.down('lg')]: {
      flexDirection: 'column',
      alignItems: 'flex-start'
    }
  },
  desktopActions: {
    marginLeft: '10px',
    display: 'flex',
    '& .modal-trigger': {
      marginRight: '5px'
    },
    [breakpointsFunc.breakpoints.down('lg')]: {
      display: 'none'
    }
  },
  tabletActions: {
    display: 'none',
    [breakpointsFunc.breakpoints.down('lg')]: {
      marginTop: '10px',
      display: 'block'
    }
  }
});
export default useStyles;